<template>
  <div
    :class="[
      'flex w-full px-6 rounded gap-4',
      backgroundColor,
      { 'py-5': !useButtonSlot || !$slots.buttons, 'pt-5': useButtonSlot && $slots.buttons },
    ]"
    :data-information-box-type="type"
  >
    <span v-if="!!icon && !hideIcon" class="w-4 h-6 flex-col justify-center items-start gap-2.5 inline-flex">
      <img :src="icon" :alt="`${type} icon`" class="w-4 h-4" />
    </span>
    <div class="flex flex-col w-full">
      <div v-if="!$slots.infoBoxContent && title" class="text-racq-dark-grey text-base-bold">{{ title }}</div>
      <div
        v-if="!$slots.infoBoxContent && description"
        class="text-racq-dark-grey text-m mt-[2px]"
        v-html="description"
      />
      <div v-if="!$slots.infoBoxContent && links" class="flex flex-col md:flex-row gap-4 mt-1">
        <a
          v-for="(link, index) in links"
          :key="index"
          :href="link.url || '#'"
          :class="getButtonClasses(link)"
          class="text-m"
          :role="!link.url ? 'button' : undefined"
          @click.prevent="handleButtonClick(link)"
          v-html="link.title"
        />
      </div>
      <slot v-if="$slots.infoBoxContent" name="infoBoxContent" class="flex flex-col w-full">
        [Named slot for info box content (infoBoxContent)]
      </slot>
    </div>
  </div>
  <div v-if="useButtonSlot && $slots.buttons" :class="['w-full px-6 rounded  pb-5 pl-[3.43rem]', backgroundColor]">
    <slot name="buttons">
      <div class="pl-4">
        <span v-if="!!icon && !hideIcon" class="w-4 h-6 flex-col justify-center items-start gap-2.5 inline-flex">
        </span>
        <div class="flex flex-col w-full"></div>
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { IInformationBox, LinkTypes } from '@/interfaces/forms/information-box.interface';
import { computed } from 'vue';

const props = defineProps<IInformationBox>();

const iconMap = {
  infodark: require('@/assets/icons/information-dark.svg'),
  info: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
};

const iconCircleMap = {
  info: require('@/assets/icons/info-information.svg'),
  infodark: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning-circle.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
};

const backgroundColorMap = {
  info: 'bg-racq-info-light-blue',
  infodark: 'bg-racq-anti-flash-white',
  warning: 'bg-racq-info-light-yellow',
  error: 'bg-racq-info-light-red',
  success: 'bg-racq-info-light-green',
};

const icon = computed(() => (props.isCircle ? iconCircleMap[props.type] : iconMap[props.type]));
const backgroundColor = computed(() => backgroundColorMap[props.type]);

function getButtonClasses(link: any) {
  if (!link) return '';

  switch (link.type) {
    case LinkTypes.BUTTON_PRIMARY:
      return 'btn btn-primary btn-sm';

    case LinkTypes.BUTTON_SECONDARY:
      return 'btn btn-secondary btn-sm';
  }
}
function handleButtonClick(link: any) {
  if (typeof link.onClick === 'function') {
    link.onClick();
  } else if (link.url) {
    window.location.href = link.url;
  }
}
</script>
